import { ArrowUpRightIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Stack, StackItem, Text } from '@prophecy/ui-v3';
import { Button } from '@prophecy/ui-v3/Button';
import { pluralize } from '@prophecy/utils/string';

type PartialFailureToastProps = {
  deletedCount: number;
  requestedCount: number;
  failedCount: number;
  onSeeDetails: () => void;
};

export function PartialFailureToast({
  deletedCount,
  requestedCount,
  failedCount,
  onSeeDetails
}: PartialFailureToastProps) {
  return (
    <Stack direction='horizontal' grow='1' alignY='center' gap={theme.spaces.x12}>
      <StackItem grow='1'>
        <Text level='sm' weight={theme.fontWeight.semiBold}>
          {deletedCount} of {requestedCount} {pluralize(requestedCount, 'branch', 'es')} deleted
        </Text>
        <Text level='sm' tone={theme.colors.gray600}>
          {failedCount} couldn&apos;t be deleted. See details to know reason and try again.
        </Text>
      </StackItem>
      <StackItem shrink='0'>
        <Button
          variant='secondaryGray'
          size='s'
          onClick={onSeeDetails}
          icon={<ArrowUpRightIcon type='default' />}
          iconPlacement='right'
          aria-label='See failure details'
          data-test-id='partial-failure-toast-see-details'>
          See Details
        </Button>
      </StackItem>
    </Stack>
  );
}
